var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {}, [_c('b-modal', {
    attrs: {
      "id": "ViewEmailLog",
      "centered": "",
      "hide-header-close": "",
      "size": "lg",
      "modal-class": "custom-modal"
    },
    on: {
      "shown": _vm.getEmailLogDetails
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "popUp-header text-center w-100",
          staticStyle: {
            "border-bottom": "0px !important"
          }
        }, [_c('h4', {
          staticClass: "heading-size"
        }, [_vm._v("Sent Item Details")])]), _c('b-button', {
          staticClass: "position-absolute",
          staticStyle: {
            "right": "1rem",
            "top": "1rem"
          },
          attrs: {
            "variant": "close",
            "aria-label": "Close"
          },
          on: {
            "click": function click($event) {
              _vm.internalShow = false;
            }
          }
        }, [_c('span', {
          attrs: {
            "aria-hidden": "true"
          }
        }, [_vm._v("×")])])];
      },
      proxy: true
    }, {
      key: "modal-footer",
      fn: function fn() {
        return [_c('b-button', {
          attrs: {
            "variant": "secondary"
          },
          on: {
            "click": function click($event) {
              _vm.internalShow = false;
            }
          }
        }, [_vm._v(" Close ")]), _c('b-button', {
          staticClass: "univ-btn w-auto p-2 pe-3 ps-3 h-100 mt-1",
          on: {
            "click": function click($event) {
              return _vm.resendEmail();
            }
          }
        }, [_vm._v(" Resend ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.internalShow,
      callback: function callback($$v) {
        _vm.internalShow = $$v;
      },
      expression: "internalShow"
    }
  }, [_c('div', {
    staticClass: "modal-scrollable-wrapper"
  }, [_c('div', {
    staticClass: "modal-scrollable scaled-content"
  }, [_c('ul', [_c('li', [_vm._v("DATE: "), _c('strong', [_vm._v(_vm._s(_vm.formattedSentDate || 'N/A'))])]), _c('li', [_vm._v("FROM: "), _c('strong', [_vm._v(_vm._s(_vm.logDetails.from_email))])]), _c('li', [_vm._v(" TO: "), _vm._l(_vm.toEmails, function (email, index) {
    return _c('span', {
      key: index,
      staticClass: "email-pill"
    }, [_vm._v(" " + _vm._s(email) + " ")]);
  })], 2), _c('li', [_vm._v(" CC: "), _vm._l(_vm.ccEmails, function (email, index) {
    return _c('span', {
      key: index,
      staticClass: "email-pill"
    }, [_vm._v(" " + _vm._s(email) + " ")]);
  })], 2), _c('li', [_vm._v(" BCC: "), _vm._l(_vm.bccEmails, function (email, index) {
    return _c('span', {
      key: index,
      staticClass: "email-pill"
    }, [_vm._v(" " + _vm._s(email) + " ")]);
  })], 2), _c('li', [_vm._v("Subject: "), _c('strong', [_vm._v(_vm._s(_vm.logDetails.email_subject))])])]), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.preview)
    }
  })])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }